import { request } from "services/api/util";

class UploadImageService {
    async uploadImage(body) {
        const config = {
            method: "post",
            url: `admin/ckEditor`,
            data: body,
            headers: {
                "content-type": "application/json;charset=UTF-8",
            },
        };
        return request(config);
    }
}

export default new UploadImageService();
